import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AnprPage } from '../anpr/anpr';
import { QrscanPage } from '../qrscan/qrscan';
import { ScansHistoryProvider } from '../../providers/scans-history/scans-history';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  mockAppEmbeddPage: string;
  visor: string;//[]=[];
  /*horaLimite: string;
  horaAviso: DateTime;*/
  constructor(public navCtrl: NavController,
              public history: ScansHistoryProvider) {
    this.mockAppEmbeddPage = "Test";
    this.history.init('');
   /* let d=new Date;
    let nd = new Date(d.getTime()) ;
    this.horaLimite=nd.toISOString();*/

  }

  public appSelected(page):any {

    if (page) this.mockAppEmbeddPage=page;

    if (page=='Avisame') {this.navCtrl.push(AnprPage)
      .then((data)=>{
        this.visor = this.history.lastANPR;
        console.log('Visor: ',this.visor);
      })
    };
    if (page=='Distintivo') {
      this.navCtrl.push(QrscanPage)
      .then((data)=>{
          this.visor=this.history.lastQR; 
          console.log('Visor:', this.visor);
        }); 
    };
    return this.mockAppEmbeddPage;
  }

  public setApp(app) {
    //console.log('app solicitada ', app);
    this.appSelected(app['page']);
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts